export default function getBackgroundColor(codename: BackgroundColors) {
  switch (codename) {
    case "pale_yellow":
      return "bg-paleYellow";
    case "salmon":
      return "bg-salmon";
    case "navy":
      return "bg-navy";
    case "light_blue":
      return "bg-lightBlue";
    case "white":
      return "bg-white";
    case "abyss":
      return "bg-abyss";
    case "terracotta":
      return "bg-terracotta";
    case "off_white":
      return "bg-offWhite";
    case "egg_yolk":
      return "bg-eggYolk";
    case "misty_rose":
      return "bg-mistyRose";
    case "mint_mist":
      return "bg-mintMist";
    case "light_gray":
      return "bg-lightGray";
    case "olive":
      return "bg-olive";
    case "dark_teal":
      return "bg-primary-dark";
    default:
    case "teal":
      return "bg-primary";
  }
}

export type BackgroundColors =
  | "pale_yellow"
  | "salmon"
  | "navy"
  | "light_blue"
  | "white"
  | "abyss"
  | "terracotta"
  | "off_white"
  | "teal"
  | "egg_yolk"
  | "misty_rose"
  | "mint_mist"
  | "light_gray"
  | "olive"
  | "dark_teal";
